var map = {
	"./amplify-amazon-button_5.entry.js": [
		636,
		12
	],
	"./amplify-auth-container.entry.js": [
		637,
		13
	],
	"./amplify-auth-fields_9.entry.js": [
		638,
		14
	],
	"./amplify-authenticator.entry.js": [
		639,
		6
	],
	"./amplify-button_3.entry.js": [
		640,
		15
	],
	"./amplify-chatbot.entry.js": [
		663,
		5
	],
	"./amplify-checkbox.entry.js": [
		641,
		16
	],
	"./amplify-confirm-sign-in_7.entry.js": [
		642,
		7
	],
	"./amplify-container.entry.js": [
		643,
		17
	],
	"./amplify-federated-buttons_2.entry.js": [
		644,
		18
	],
	"./amplify-federated-sign-in.entry.js": [
		645,
		19
	],
	"./amplify-form-field_4.entry.js": [
		646,
		20
	],
	"./amplify-greetings.entry.js": [
		647,
		21
	],
	"./amplify-icon-button.entry.js": [
		648,
		22
	],
	"./amplify-icon.entry.js": [
		649,
		8
	],
	"./amplify-link.entry.js": [
		650,
		23
	],
	"./amplify-nav_2.entry.js": [
		651,
		24
	],
	"./amplify-photo-picker.entry.js": [
		652,
		25
	],
	"./amplify-picker.entry.js": [
		653,
		26
	],
	"./amplify-radio-button_3.entry.js": [
		654,
		9
	],
	"./amplify-s3-album.entry.js": [
		655,
		0,
		27
	],
	"./amplify-s3-image-picker.entry.js": [
		656,
		0,
		28
	],
	"./amplify-s3-image.entry.js": [
		657,
		0,
		29
	],
	"./amplify-s3-text-picker.entry.js": [
		658,
		0,
		30
	],
	"./amplify-s3-text.entry.js": [
		659,
		0,
		31
	],
	"./amplify-select-mfa-type.entry.js": [
		660,
		32
	],
	"./amplify-sign-in-button.entry.js": [
		661,
		10
	],
	"./amplify-tooltip.entry.js": [
		662,
		33
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 630;
module.exports = webpackAsyncContext;